import { Entity } from '@api/api/entity-schema';
import { mapEntity } from '@api/mappers/mapEntity';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { UndefinedInitialDataOptions } from '@tanstack/react-query';
import { postEntity } from '@terminal/services/entities/entity-service';
import { ApiFetchResponse } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_ENTITY = 'QUERY_KEY_ENTITY';

export enum FILTER {
  id = 1,
  tag = 2,
}

export const mapEntities = (entities: Entity[]) => entities.map(mapEntity);

export const createEntityQueryOptions = (
  entityTag: string = ''
): UndefinedInitialDataOptions<
  ApiFetchResponse<Entity>,
  Error,
  ApiFetchResponse<Entity>,
  string[]
> => ({
  queryKey: [QUERY_KEY_ENTITY, entityTag],
  queryFn: ({ signal }) => postEntity(entityTag, signal),
  staleTime: getTimeTillEndOfDayMs(),
  enabled: !!entityTag,
});
